import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-folder-warning",
  "use": "icon-si-glyph-folder-warning-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-folder-warning\" id=\"icon-si-glyph-folder-warning\"><title>937</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(1.000000, 2.000000)\" fill=\"#434343\"><g><path d=\"M7.35,3 L5.788,0.042 L2.021,0.042 L2.021,1.063 L0.023,1.063 L0.023,10.976 L1.044,10.976 L1.045,11.976 L15.947,11.976 L15.968,3 L7.35,3 L7.35,3 Z M4.021,11.021 L8.521,3.98 L12.98,11.021 L4.021,11.021 L4.021,11.021 Z\" class=\"si-glyph-fill\" /><path d=\"M13.964,1.982 L13.964,1.042 L8.024,1.042 L8.354,1.982 L13.964,1.982 Z\" class=\"si-glyph-fill\" /></g><rect x=\"8\" y=\"6\" width=\"1\" height=\"1.956\" class=\"si-glyph-fill\" /><rect x=\"8\" y=\"9\" width=\"1\" height=\"0.973\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-folder-warning.svg
// module id = Z+u/
// module chunks = 62